var _rect, _path, _g, _path2, _path3, _path4, _path5, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#eee",
    height: 52.515,
    rx: 2,
    width: 47.96,
    x: 3,
    y: 8.485
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.00001 10.48511h7.96039c0-1.10455-.89545-2-2-2h-43.96039c-1.10457 0-2 .89543-2 2v48.51489c0 1.10455.89545 2 2 2v-12.51489c0-20.98682 17.01318-38 38-38z",
    fill: "#e0e0e0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f78c1e"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 10.97,
    rx: 2.505,
    width: 5.01,
    x: 30.475,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10.97,
    rx: 2.505,
    width: 5.01,
    x: 41.475,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10.97,
    rx: 2.505,
    width: 5.01,
    x: 18.475,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10.97,
    rx: 2.505,
    width: 5.01,
    x: 7.475,
    y: 3
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31.0658 42.58093-.50409 6.56696 6.56702-.50409 1.5752-1.57526-6.06287-6.06286z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.888 30.614h25.842v8.574h-25.842z",
    fill: "#f9a01b",
    transform: "matrix(.707 -.707 .707 .707 -11.554 41.907)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m55.97669 29.79577s1-.99999 1-.99999l-6.06287-6.06287-18.27277 18.27277 1 1 12.2099-12.2099c2.79614-2.79614 7.32958-2.79614 10.12572 0z",
    fill: "#f78f1e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m60.41419 22.52985-3.23444-3.23444c-.78107-.78107-2.04742-.78107-2.82843 0l-3.4375 3.4375 6.06287 6.06287 3.4375-3.4375c.78107-.78101.78107-2.04736 0-2.82843z",
    fill: "#f06392"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#616261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.97999 21.73291h-34c-.55225 0-1 .44775-1 1s.44775 1 1 1h34c.55225 0 1-.44775 1-1s-.44775-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.97999 33h11c.55225 0 1-.44775 1-1s-.44775-1-1-1h-11c-.55225 0-1 .44775-1 1s.44775 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.2129 31h-8.23779c-.55225 0-1 .44775-1 1s.44775 1 1 1h8.23779c.55225 0 1-.44775 1-1s-.44775-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.97999 42.26709h14.99512c.55225 0 1-.44775 1-1s-.44775-1-1-1h-14.99512c-.55225 0-1 .44775-1 1s.44775 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2378 49.53418h-15.25781c-.55225 0-1 .44775-1 1s.44775 1 1 1h15.25781c.55225 0 1-.44775 1-1s-.44775-1-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.6e5dfd2b1f262873cf5b93c991cc7a7f.svg";
export { ForwardRef as ReactComponent };